import React, { useState, useRef } from 'react'
import { useStateValue } from '@State'

export const CertReason = ({ disable }) => {
  const [state, dispatch] = useStateValue()
  const [editReason, setEditReason] = useState(false)
  const reasonInput = useRef(null)

  const handleChange = () => {
    dispatch({
      type: 'UPDATE_CERT_INFO',
      payload: { reason: reasonInput.current.value },
    })
    setEditReason(false)
  }

  if (editReason) {
    return (
      <div className="text-center input_element" id="reason">
        <input
          type="text"
          id="reason_input"
          ref={reasonInput}
          defaultValue={state.certInfo.reason}
          onBlur={handleChange}
        />
      </div>
    )
  }

  return (
    <div
      className={disable ? 'text-center' : 'text-center input_element'}
      id="reason"
    >
      {state.certInfo.reason}
      <div
        className={disable ? '' : 'icon icon_pencil'}
        id="reason_pencil"
        onClick={() => setEditReason(true)}
      />
    </div>
  )
}
